
import React from 'react'

import { ChevronLastIcon, ChevronFirstIcon, ChevronLeftIcon, ChevronRightIcon } from 'lucide-react'

import { SkipNext as SkipNextIcon, SkipPrevious as SkipPreviousIcon } from '@mui/icons-material'
import { Pagination as MuiPagination, PaginationProps as MuiPaginationProps, PaginationItem as MuiPaginationItem } from '@mui/material'
import { styled, useTheme, alpha  } from '@mui/material/styles';

const StyledMuiPagination = styled(MuiPagination)<MuiPaginationProps>(({ theme }) => ({
 

}))

export interface PaginationProps {
  page: number
  count: number
  onChange?: (page: number) => void, 
  sx: object
}

export const Pagination = (props: PaginationProps) => {
  const { page = 1, count = 0, onChange, sx } = props
  const theme = useTheme()
  return (
    <StyledMuiPagination
      sx={sx}
      count={count}
      page={page}
      siblingCount={1}
      onChange={(_, page) => onChange?.(page)}
      showFirstButton
      showLastButton
      shape="rounded" 
      renderItem={item =>
        <MuiPaginationItem
        sx={{
          svg: {
            strokeWidth: 1,
            fill: 'none !important',
            width: '18px',
            height: '18px'
          },
          boxShadow: 'none',
          border: `1px solid ${theme.palette.primary[100]}`,
          borderRadius: 1.5,
          fontSize: 12,
          '& .Mui-selected': {
            background: theme.palette.primary[50],
          },
        }}
        slots={{
          first: ChevronFirstIcon,
          last: ChevronLastIcon,
          previous: ChevronLeftIcon,
          next: ChevronRightIcon
        }} {...item} />
      }
    />
  )
}
